import React from 'react';

import styled from '@emotion/styled';
import { Divider, Space } from 'antd';
import JobStatus, { JOB_STATUS } from 'app/components/Status/JobStatus';
import { Text } from 'app/components/Typography/Text';
import { Title } from 'app/components/Typography/Title';
import Card from '..';
import get from 'lodash/get';
import Avatar from 'app/components/Avatar';
import Tooltip from 'app/components/Tooltip';

const WrapperHeader = styled.div`
  margin-bottom: 8px;
  display: flex;
  width: 100%;
  padding-top: 4px;
  padding-bottom: 4px;

  .ant-card-meta {
    width: calc(100% - 12px);
  }
  .ant-card-meta-title {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    h5 {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ant-card-meta-detail > div:not(:last-child) {
    margin-bottom: 0px;
  }
  > .ant-divider {
    min-height: 40px;
    height: auto;
    width: 4px;
    border-radius: 18px;
    background: #196eff;
    margin-right: 16px;
    margin-left: 0px;
  }
  .ant-card-meta-description {
    > a {
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      letter-spacing: 0.01em;
      text-align: left;
      color: #8991a0;
    }
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const WrapperSubHeader = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  > .ant-card-meta-detail > div:not(:last-child) {
    margin-bottom: 0px;
  }
  .ant-card-meta-detail {
    .ant-card-meta-title {
      a {
        font-size: 12px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0.005em;
        text-align: left;
        color: rgba(35, 43, 58, 1);
      }
    }
  }

  .ant-card-meta-description {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .info {
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 0.005em;
      text-align: left;
      color: rgba(35, 43, 58, 1);
    }
    .ant-avatar-string {
      transform: scale(0.533333) translateX(-50%) translateY(-25%) !important;
    }
  }
`;
const StyledCard = styled(Card)`
  margin: 14px 0;
  box-shadow: 0px 1px 6px 0px rgba(165, 178, 200, 0.2);
  box-shadow: 0px 2px 4px 1px rgba(165, 178, 200, 0.1);
  border-radius: 8px;
  .ant-card-body {
    padding: 12px;
  }
`;

const StyledTooltip = styled(Tooltip)`
  .ant-tooltip-inner {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.01em;
    text-align: left;
    color: #c4c8d0;
    padding-top: 8px;
  }
`;
export const EventCard = ({
  title,
  description,
  subtitle,
  image,
  info,
  status,
  state
}: {
  title: string;
  state: string;
  description: string;
  subtitle: string;
  image: string;
  status: string;
  info: string;
}) => {
  return (
    <StyledCard>
      <WrapperHeader>
        <Divider type="vertical"></Divider>
        <Card.Meta
          title={
            <Title style={{ marginBottom: 0 }} level={5}>
              <div>{title}</div>
              {state}
            </Title>
          }
          description={
            <StyledTooltip placement="bottomRight" title={description}>
              <a onClick={(e) => e.preventDefault()}>{description}</a>
            </StyledTooltip>
          }
        ></Card.Meta>
      </WrapperHeader>

      <WrapperSubHeader>
        <Card.Meta
          title={
            <StyledTooltip placement="bottomRight" title={subtitle}>
              <a onClick={(e) => e.preventDefault()}>{subtitle}</a>
            </StyledTooltip>
          }
          description={
            <Space size={4}>
              <Avatar
                src={image}
                placeholder={Avatar.PLACE_HOLDERS['USER_PROFILE']}
              ></Avatar>
              <Text className="info">{info}</Text>
            </Space>
          }
        ></Card.Meta>
      </WrapperSubHeader>
      <JobStatus status={status as any}>
        {get(JOB_STATUS, [status], '')}
      </JobStatus>
    </StyledCard>
  );
};
